import '@aws-amplify/ui-react/styles.css';
import React, { useCallback, useEffect, useState } from "react";
import { API } from 'aws-amplify';
import debounce from 'lodash.debounce'
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import CheckoutPage from './CheckoutPage';
import GiddyupAppBar from './GiddyupAppBar';
import VideosPage from './VideosPage';

function Router(props) {
  const { signOut, user, user: { attributes: { sub } = {} } = {} } = props;

  const [hasPaid, setHasPaid] = useState()

  useEffect(() => {
    // TODO only use fetch dynamo to see if has paid
    const query = new URLSearchParams(window.location.search);
    if (query.get("success")) {
      setHasPaid(true)
    }
    if (document.URL.includes('/signup')) {
      window.history.pushState('home', 'Home', '/')
    }
  }, [])

  useEffect(() => {
    if (hasPaid) {
      if (document.URL.includes('/free-trial')) {
        window.history.pushState('home', 'Home', '/')
      }
    }
  }, [hasPaid])

  const fetchUser = useCallback(
    debounce(async () => {
      if (!sub) {
        return
      }
      const result = await API.get('appApi', `/user/${sub}`)
      setHasPaid(!!result.user.checkout)
      const query = new URLSearchParams(window.location.search);
      if (query.get("success")) {
        setHasPaid(true)
      }
    }, 500),
    [sub]
  )
  useEffect(() => {
    fetchUser()
  }, [fetchUser])

  return (
    <div className="Router">
      <GiddyupAppBar signOut={signOut} user={user} />
      {hasPaid === undefined &&
        (<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh', width: '100vw' }}>
          <CircularProgress />
        </Box>)
      }
      {
        hasPaid === false && <CheckoutPage user={user} />
      }
      {
        hasPaid && <VideosPage user={user} />
      }
    </div>
  );
}

export default Router;
